// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as CartProduct from "../Cart/CartProduct.res.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let TaxValueNotFound = /* @__PURE__ */Primitive_exceptions.create("OrderProductFormAutoPicker.TaxValueNotFound");

let Raw = {};

let query = Client.gql(["query MissingStockVariantsQuery($after: String, $supplierId: String!)  {\nmissingStockVariants(first: 50, after: $after, filterBy: {supplierId: {_equals: $supplierId}})  {\n__typename  \npageInfo  {\n__typename  \nendCursor  \nhasNextPage  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nid  \nformattedName  \nformattedDescription  \nstockKeepingUnit  \npurchasedPrice  \npackaging  \nbulk  \ncapacityPrecision  \nmaxStockThreshold  \nstock  {\n__typename  \nrawQuantity  \n}\n\nproduct  {\n__typename  \nkind  \ntax  {\n__typename  \nvalue  \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.missingStockVariants;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.endCursor;
  let value$4 = value$2.hasNextPage;
  let value$5 = value$1.edges;
  return {
    missingStockVariants: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        endCursor: !(value$3 == null) ? value$3 : undefined,
        hasNextPage: !(value$4 == null) ? value$4 : undefined
      },
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.stockKeepingUnit;
        let value$3 = value$1.purchasedPrice;
        let value$4 = value$1.packaging;
        let value$5 = value$1.bulk;
        let value$6 = value$1.capacityPrecision;
        let value$7 = value$1.maxStockThreshold;
        let value$8 = value$1.stock;
        let value$9 = value$8.rawQuantity;
        let value$10 = value$1.product;
        let value$11 = value$10.kind;
        let tmp;
        switch (value$11) {
          case "BEER" :
            tmp = "BEER";
            break;
          case "SIMPLE" :
            tmp = "SIMPLE";
            break;
          case "SPIRITUOUS" :
            tmp = "SPIRITUOUS";
            break;
          case "WINE" :
            tmp = "WINE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$12 = value$10.tax;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            formattedName: value$1.formattedName,
            formattedDescription: value$1.formattedDescription,
            stockKeepingUnit: !(value$2 == null) ? value$2 : undefined,
            purchasedPrice: !(value$3 == null) ? value$3 : undefined,
            packaging: !(value$4 == null) ? value$4 : undefined,
            bulk: !(value$5 == null) ? value$5 : undefined,
            capacityPrecision: !(value$6 == null) ? value$6 : undefined,
            maxStockThreshold: !(value$7 == null) ? value$7 : undefined,
            stock: {
              __typename: value$8.__typename,
              rawQuantity: !(value$9 == null) ? value$9 : undefined
            },
            product: {
              __typename: value$10.__typename,
              kind: tmp,
              tax: {
                __typename: value$12.__typename,
                value: value$12.value
              }
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.missingStockVariants;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.product;
    let value$3 = value$2.tax;
    let value$4 = value$3.value;
    let value$5 = value$3.__typename;
    let tax = {
      __typename: value$5,
      value: value$4
    };
    let value$6 = value$2.kind;
    let kind = value$6 === "SPIRITUOUS" ? "SPIRITUOUS" : (
        value$6 === "BEER" ? "BEER" : (
            value$6 === "WINE" ? "WINE" : "SIMPLE"
          )
      );
    let value$7 = value$2.__typename;
    let product = {
      __typename: value$7,
      kind: kind,
      tax: tax
    };
    let value$8 = value$1.stock;
    let value$9 = value$8.rawQuantity;
    let rawQuantity = value$9 !== undefined ? value$9 : null;
    let value$10 = value$8.__typename;
    let stock = {
      __typename: value$10,
      rawQuantity: rawQuantity
    };
    let value$11 = value$1.maxStockThreshold;
    let maxStockThreshold = value$11 !== undefined ? value$11 : null;
    let value$12 = value$1.capacityPrecision;
    let capacityPrecision = value$12 !== undefined ? value$12 : null;
    let value$13 = value$1.bulk;
    let bulk = value$13 !== undefined ? value$13 : null;
    let value$14 = value$1.packaging;
    let packaging = value$14 !== undefined ? value$14 : null;
    let value$15 = value$1.purchasedPrice;
    let purchasedPrice = value$15 !== undefined ? value$15 : null;
    let value$16 = value$1.stockKeepingUnit;
    let stockKeepingUnit = value$16 !== undefined ? value$16 : null;
    let value$17 = value$1.formattedDescription;
    let value$18 = value$1.formattedName;
    let value$19 = value$1.id;
    let value$20 = value$1.__typename;
    let node = {
      __typename: value$20,
      id: value$19,
      formattedName: value$18,
      formattedDescription: value$17,
      stockKeepingUnit: stockKeepingUnit,
      purchasedPrice: purchasedPrice,
      packaging: packaging,
      bulk: bulk,
      capacityPrecision: capacityPrecision,
      maxStockThreshold: maxStockThreshold,
      stock: stock,
      product: product
    };
    let value$21 = value.__typename;
    return {
      __typename: value$21,
      node: node
    };
  });
  let value$3 = value$1.pageInfo;
  let value$4 = value$3.hasNextPage;
  let hasNextPage = value$4 !== undefined ? value$4 : null;
  let value$5 = value$3.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$3.__typename;
  let pageInfo = {
    __typename: value$6,
    endCursor: endCursor,
    hasNextPage: hasNextPage
  };
  let value$7 = value$1.__typename;
  let missingStockVariants = {
    __typename: value$7,
    pageInfo: pageInfo,
    edges: edges
  };
  return {
    missingStockVariants: missingStockVariants
  };
}

function serializeVariables(inp) {
  let a = inp.after;
  return {
    after: a !== undefined ? a : undefined,
    supplierId: inp.supplierId
  };
}

function makeVariables(after, supplierId, param) {
  return {
    after: after,
    supplierId: supplierId
  };
}

let MissingStockVariantsQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let MissingStockVariantsQuery_refetchQueryDescription = include.refetchQueryDescription;

let MissingStockVariantsQuery_use = include.use;

let MissingStockVariantsQuery_useLazy = include.useLazy;

let MissingStockVariantsQuery_useLazyWithVariables = include.useLazyWithVariables;

let MissingStockVariantsQuery = {
  MissingStockVariantsQuery_inner: MissingStockVariantsQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: MissingStockVariantsQuery_refetchQueryDescription,
  use: MissingStockVariantsQuery_use,
  useLazy: MissingStockVariantsQuery_useLazy,
  useLazyWithVariables: MissingStockVariantsQuery_useLazyWithVariables
};

function runScanMissingStockVariants(apolloClient, supplierId, cursor, dataOpt, onDone, param) {
  let data = dataOpt !== undefined ? dataOpt : [];
  Future.get(FuturePromise.fromPromise(apolloClient.rescript_query({
    query: query,
    Raw: Raw,
    parse: parse,
    serialize: serialize,
    serializeVariables: serializeVariables
  }, undefined, undefined, "NetworkOnly", undefined, {
    after: cursor,
    supplierId: supplierId
  })), response => {
    if (response.TAG !== "Ok") {
      return onDone("Error", []);
    }
    let match = response._0;
    if (match.TAG !== "Ok") {
      return onDone("Error", []);
    }
    let match$1 = match._0;
    let match$2 = match$1.data.missingStockVariants;
    let match$3 = match$2.pageInfo;
    let match$4 = match$3.hasNextPage;
    if (match$4 !== undefined && match$4) {
      if (match$1.error !== undefined) {
        return onDone("Error", []);
      } else {
        return runScanMissingStockVariants(apolloClient, supplierId, match$3.endCursor, data.concat(match$2.edges), onDone, undefined);
      }
    }
    if (match$1.error !== undefined) {
      return onDone("Error", []);
    }
    let allVariants = data.concat(match$2.edges).filter(param => Stdlib_Option.getOr(param.node.bulk, false) === false);
    onDone({
      TAG: "Success",
      _0: allVariants.length
    }, allVariants);
  });
}

function OrderProductFormAutoPicker(props) {
  let onPickProducts = props.onPickProducts;
  let onQueryStatusChange = props.onQueryStatusChange;
  let supplierName = props.supplierName;
  let supplierId = props.supplierId;
  let orderId = props.orderId;
  let status = props.status;
  let apolloClient = ReasonMLCommunity__ApolloClient.React.useApolloClient();
  let match = React.useState(() => false);
  let setOpened = match[1];
  let opened = match[0];
  React.useEffect(() => {
    if (opened || orderId !== undefined || supplierName === undefined || supplierId === "") {
      
    } else {
      setOpened(param => true);
    }
  }, [
    supplierId,
    supplierName
  ]);
  React.useEffect(() => {
    if (status === "Loading") {
      runScanMissingStockVariants(apolloClient, supplierId, undefined, undefined, (status, data) => {
        onQueryStatusChange(status);
        onPickProducts(data.map(param => {
          let variant = param.node;
          let rawQuantity = CartProduct.makeQuantity(variant.maxStockThreshold, variant.stock.rawQuantity, variant.packaging, variant.capacityPrecision, undefined);
          let description = variant.formattedDescription;
          let tmp = description === "" ? I18n.t("Description not filled in") : description;
          return CartProduct.makeProductInput(variant.id, variant.formattedName, tmp, variant.stockKeepingUnit, variant.stock.rawQuantity, variant.packaging, variant.product.tax.value, variant.purchasedPrice, rawQuantity, undefined, undefined, undefined);
        }));
      }, undefined);
    }
  }, [status]);
  return null;
}

let make = React.memo(OrderProductFormAutoPicker, (oldProps, newProps) => {
  if (oldProps.status === newProps.status && oldProps.supplierId === newProps.supplierId) {
    return oldProps.supplierName === newProps.supplierName;
  } else {
    return false;
  }
});

export {
  TaxValueNotFound,
  MissingStockVariantsQuery,
  runScanMissingStockVariants,
  make,
}
/* query Not a pure module */
